// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ed363e27","455":"73c8df53","950":"b22a0e8d","977":"63d7de3a"}[chunkId] + ".chunk.js";
};